import getVoidsInCaption from './getVoidsInCaption';
import SLATE_NODES from '../../constants/slateNodes';

const getVoidNodesCount = (editor, selectedBlocks) => {
  let citationCount = 0;
  let figureCount = 0;
  let equationCount = 0;

  /**
   * When selection is on only image/figure caption nodes
   */
  if (
    selectedBlocks.length === 1 &&
    selectedBlocks[0].type === SLATE_NODES.FIGURE
  ) {
    const nodes = selectedBlocks[0].nodes.toArray();
    let selectedNodesInCaption;
    if (
      nodes[0].type === SLATE_NODES.IMAGE &&
      nodes[0].object === SLATE_NODES.BLOCK
    ) {
      let figureCaptionNode;
      if (nodes.length === 1) figureCaptionNode = editor.value.nextBlock;
      else if (nodes.length === 2) [, figureCaptionNode] = nodes;
      selectedNodesInCaption = figureCaptionNode.nodes.toArray();
      figureCount = 1;
    } else {
      selectedNodesInCaption = nodes[0].nodes.toArray();
    }

    /**
     * Check if there is a citation or equation inside the text
     */
    const {
      citationCount: citationsInCaption,
      equationCount: equationsInCaption,
    } = getVoidsInCaption(selectedNodesInCaption);
    citationCount = citationsInCaption;
    equationCount = equationsInCaption;

    return { citationCount, figureCount, equationCount };
  }

  selectedBlocks.some((selectedBlock) => {
    if (
      !figureCount &&
      selectedBlock.object === SLATE_NODES.BLOCK &&
      selectedBlock.type === SLATE_NODES.FIGURE
    ) {
      figureCount = 1;
    }

    /**
     * Block level equation
     */
    if (
      !equationCount &&
      selectedBlock.type === SLATE_NODES.IMAGE &&
      selectedBlock.data.get('imageType') === SLATE_NODES.EQUATION
    ) {
      equationCount = 1;
    }

    const nodes = selectedBlock.nodes.toArray();
    nodes.some((node) => {
      /**
       * loop through figcaption nodes too
       */
      if (
        node.type === SLATE_NODES.FIGURE_CAPTION &&
        node.object === SLATE_NODES.BLOCK
      ) {
        const selectedNodesInCaption = node.nodes.toArray();
        if (!citationCount) {
          const {
            citationCount: citationsInCaption,
            equationCount: equationsInCaption,
          } = getVoidsInCaption(selectedNodesInCaption);
          citationCount = citationsInCaption;
          equationCount = equationsInCaption;
        }
      }

      if (
        !citationCount &&
        node.object === SLATE_NODES.INLINE &&
        node.type === SLATE_NODES.SPAN
      ) {
        citationCount = 1;
      } else if (
        !equationCount &&
        node.type === SLATE_NODES.IMAGE &&
        node.data.get('imageType') === SLATE_NODES.EQUATION
      ) {
        equationCount = 1;
      } else if (citationCount && equationCount) return true;

      return false;
    });

    if (citationCount && figureCount && equationCount) {
      return true;
    }
    return false;
  });
  return { citationCount, figureCount, equationCount };
};

export default getVoidNodesCount;
